import { isNil, isEmpty, not, memoizeWith, identity } from "ramda";

export const isPropNilOrEmpty = (object, prop) =>
  isNil(object[prop]) || isEmpty(object[prop]);

export const isPropNotEmpty = (object, prop) =>
  not(isNil(object[prop])) && not(isEmpty(object[prop]));

export function keysLength(object) {
  return Object.keys(object).length;
}

function defaultKeyExtractor(item, defaultKey) {
  return defaultKey;
}

export function fromEntriesWith(array, keyExtractor = defaultKeyExtractor) {
  return Object.fromEntries(
    array.map((element, index) => [keyExtractor(element, index), element])
  );
}

export function mergeFromEntriesWith(
  keyExtractor = defaultKeyExtractor,
  transformator = identity
) {
  return function mergeFromEntries(...args) {
    const arraysNumber = args.length;
    const object = {};
    for (let i = 0; i < arraysNumber; i += 1) {
      const currentArray = args[i] || [];
      for (let j = 0; j < currentArray.length; j += 1) {
        const key = keyExtractor(currentArray[j]);
        object[key] = transformator(currentArray[j], object[key]);
      }
    }
    return object;
  };
}

export const toArrayMemoized = memoizeWith(identity, (object) =>
  Object.values(object)
);
